import Client from '@/utils/client'

export const clientMixin = {
  data () {
    return {
      isLoading: true,
      isLoadinGeoJson: true
    }
  },
  computed: {
    client () {
      const { local, url, locale, remoteURL, zone } = this.config.client || {}

      const client = new Client(local, zone, locale, remoteURL, url)

      return client
    }
  },
  methods: {
    getData (file) {
      return this.client.getData(file)
    },
    getGeoJson (file) {
      return this.client.getGeoJson(file)
    }
  }
}
